export default "__VITE_ASSET__BZRrs_SB__"